import { Fragment } from 'react';
import { useDocumentTitle } from 'usehooks-ts';

import type { FunctionComponent, PropsWithChildren } from 'react';

export const PageWithTitle: FunctionComponent<PropsWithChildren<{ readonly title: string }>> = ({
    children,
    title,
}) => {
    useDocumentTitle(title);

    return <Fragment>{children}</Fragment>;
};
